import React from 'react';
import { Spinner } from 'components/UI';
import styles from './TeamRevenueDetailTable.module.scss';

interface TeamRevenueData {
    staff: string;
    totalAppointments: number;
    grossSales: number;
    discounts: number;
    refunds: number;
    netSales: number;
    percentOfTotalNetSales: number;
    avgOrderValue: number;
    tips: number;
}

interface TeamRevenueDetailTableProps {
    loading: boolean;
    data: TeamRevenueData[] | null;
}

export const TeamRevenueDetailTable: React.FunctionComponent<TeamRevenueDetailTableProps> = props => {
    const formatCurrency = (amount: number) => {
        return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const formatPercentage = (percent: number) => {
        return `${percent.toFixed(1)}%`;
    };

    return (
        <div className={styles.root}>
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead className={styles.header}>
                        <tr>
                            <th className={styles.headerCell}>Staff</th>
                            <th className={styles.headerCell}>Total Appointments</th>
                            <th className={styles.headerCell}>Gross Sales</th>
                            <th className={styles.headerCell}>Discounts</th>
                            <th className={styles.headerCell}>Refunds</th>
                            <th className={styles.headerCell}>Net Sales</th>
                            <th className={styles.headerCell}>% of total Net Sales</th>
                            <th className={styles.headerCell}>Avg Order Value</th>
                            <th className={styles.headerCell}>Tips</th>
                        </tr>
                    </thead>
                    <tbody className={styles.body}>
                        {props.loading ? (
                            <tr>
                                <td
                                    colSpan={9}
                                    className={styles.loadingCell}
                                >
                                    <Spinner className={styles.spinner} />
                                </td>
                            </tr>
                        ) : (
                            props.data?.map((item, index) => (
                                <tr
                                    key={index}
                                    className={styles.row}
                                >
                                    <td className={styles.cell}>{item.staff}</td>
                                    <td className={styles.cell}>{item.totalAppointments}</td>
                                    <td className={styles.cell}>{formatCurrency(item.grossSales)}</td>
                                    <td className={styles.cell}>{formatCurrency(item.discounts)}</td>
                                    <td className={styles.cell}>{formatCurrency(item.refunds)}</td>
                                    <td className={styles.cell}>{formatCurrency(item.netSales)}</td>
                                    <td className={styles.cell}>{formatPercentage(item.percentOfTotalNetSales)}</td>
                                    <td className={styles.cell}>{formatCurrency(item.avgOrderValue)}</td>
                                    <td className={styles.cell}>{formatCurrency(item.tips)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TeamRevenueDetailTable;
